import * as React from 'react';
import { IPreviewProps } from './types';
import { PREVIEW_TEXT, PREVIEW_TEXT_ADMIN, PREVIEW_TITLE } from './constants';
import './_Preview.scss';
import { CLASS_PREVIEW } from '../../../constants';
import { Button, Icon, Switch } from 'kui';
import { ListItem } from '../../../../../base/components/ListItem/ListItem';
import ReactHtmlParser from 'react-html-parser';
import { CardPreviewHOC } from '../../hocs/CardPreviewHOC/CardPreviewHOC';

export function Preview ({
    boardId,
    isAdmin,
    settings,
    onOpenSettings,
    onToggle,
}: IPreviewProps) {
    const className = CLASS_PREVIEW;
    const classText = className + '__text';
    const classItem = className + '__item';

    const QuestionIcon = require(`!!@svgr/webpack!./icons/question.svg`).default;

    React.useEffect(() => {
        if (!isAdmin) return;

        const link = document.querySelector(`.${classText} a`) as HTMLElement;
        if (link) {
            link.addEventListener('click', onOpenSettings);
        }
    }, []);

    return <>
        <CardPreviewHOC boardId={boardId} />
        <span className={className + '__title'}>{PREVIEW_TITLE}</span>
        <span className={classText}>{PREVIEW_TEXT}</span>
        {isAdmin && <span className={classText}>{ReactHtmlParser(PREVIEW_TEXT_ADMIN)}</span>}
        <div className={className + '__settings'}>
            {settings.map(setting => {
                const {
                    key,
                    icon,
                    isHideCount,
                    link,
                    localIcon,
                    value,
                    name,
                    cardsCount,
                } = setting;
                const LocalIcon = localIcon && require(`!!@svgr/webpack!./icons/${localIcon}.svg`).default;
                const iconEl = localIcon ? <span className={'kui-icon kui-icon--24'}><LocalIcon /></span>
                    : <Icon xlink={icon} size={24} />;
                return <ListItem
                    key={key}
                    className={classItem}
                    img={iconEl}
                    text={<>
                        {name}
                        {!isHideCount && <span className={classItem + '-counter'}>{cardsCount}</span>}
                    </>}
                    actions={<>
                        {link && <Button
                            className={classItem + '-info'}
                            variant={'icon'}
                            href={link}
                            target={'_blank'}
                        >
                            <QuestionIcon />
                        </Button>}
                        <Switch checked={value} onChange={() => onToggle(key)}/>
                    </>}
                />;
            })}
        </div>
    </>
}
